<template>
    <b-container fluid v-if="details" class="pb-4">
        <div>
            <h5 class="pt-3">Login and Billing Notification Email</h5>
            <hr />
        </div>
        <validation-observer :initial-values="initialFormValues" ref="account_form" v-slot="{ meta }">
            <b-row class="flex-column flex-md-row w-100">
                <b-col>
                    <validation-provider
                        name="email"
                        v-slot="{ errors, handleChange }"
                        rules="email|required"
                    >
                        <form-input
                            :leftIcon="['fas', 'at']"
                            v-model="details.client.user.email"
                            :error="errors[0]"
                            floatingLabel="Login Email"
                            @input="handleChange"
                        ></form-input>
                    </validation-provider>
                </b-col>
                <b-col v-if="details.client.is_subscriber" class="pr-md-0">
                    <validation-provider name="email_cc" v-slot="{ errors, handleChange }" rules="email">
                        <form-input
                            :leftIcon="['fas', 'at']"
                            v-model="details.client.user.email_cc"
                            :error="errors[0]"
                            floatingLabel="Email CC"
                            @input="handleChange"
                        ></form-input>
                    </validation-provider>
                </b-col>
                <b-col v-if="!details.client.is_subscriber" class="pr-md-0">
                    <validation-provider name="email_cc" v-slot="{ errors, handleChange }" rules="email">
                        <form-input
                            floatingLabel="Email CC"
                            :leftIcon="['fas', 'at']"
                            :error="errors[0]"
                            v-model="details.client.email"
                            @input="handleChange"
                        ></form-input>
                    </validation-provider>
                </b-col>
            </b-row>
            <b-row class="flex-column flex-md-row w-100">
                <b-col>
                    <form-input
                        :leftIcon="['fas', 'calendar-days']"
                        :value="formatDate(details.client.user.date_joined)"
                        floatingLabel="Registered"
                        :disabled="true"
                    ></form-input>
                </b-col>
                <b-col class="pr-md-0">
                    <form-input
                        :leftIcon="['fas', 'calendar-days']"
                        :value="formatDate(details.client.user.last_login)"
                        floatingLabel="Last Login"
                        :disabled="true"
                    ></form-input>
                </b-col>
            </b-row>
            <b-row class="flex-column flex-md-row w-100">
                <b-col>
                    <form-api-key-field :value="details.client.clientsettings.api_key_2" label="API Key v2:" />
                </b-col>
                <b-col class="pr-md-0">
                    <form-api-key-field
                        :value="details.client.clientsettings.limited_api_key_2"
                        label="Wordpress Plugin Key v2:"
                    />
                </b-col>
            </b-row>
            <b-row class="flex-column flex-md-row w-100">
                <b-col cols="12" md="6">
                    <div class="d-flex">
                        <div class="d-flex flex-column mr-3">
                            <span>Active:</span>
                            <form-square-switch
                                class="mr-2 account-details-switch"
                                :labels="{
                                    checked: 'ON',
                                    unchecked: 'OFF',
                                }"
                                v-model="details.client.user.is_active"
                                :isToolbar="true"
                                :sync="true"
                            />
                        </div>
                        <div class="d-flex flex-column mr-3">
                            <span>Validated:</span>
                            <form-square-switch
                                class="mr-2 account-details-switch"
                                :labels="{
                                    checked: 'ON',
                                    unchecked: 'OFF',
                                }"
                                :isToolbar="true"
                                :sync="true"
                                v-model="details.client.user.is_validated"
                            />
                        </div>
                        <div v-if="details.client.is_subscriber" class="d-flex flex-column mr-3">
                            <span>Allow Airbnb:</span>
                            <form-square-switch
                                class="mr-2 account-details-switch"
                                :labels="{
                                    checked: 'ON',
                                    unchecked: 'OFF',
                                }"
                                :isToolbar="true"
                                :sync="true"
                                v-model="details.client.clientsettings.allow_airbnb"
                            />
                        </div>
                        <div v-if="details.client.is_subscriber" class="d-flex flex-column mr-3">
                            <span>Allow Nextpax:</span>
                            <form-square-switch
                                class="mr-2 account-details-switch"
                                :labels="{
                                    checked: 'ON',
                                    unchecked: 'OFF',
                                }"
                                :isToolbar="true"
                                :sync="true"
                                v-model="details.client.clientsettings.allow_nextpax"
                            />
                        </div>
                        <div v-if="details.client.is_subscriber" class="d-flex flex-column mr-3">
                            <span>Allow VRBO:</span>
                            <form-square-switch
                                class="mr-2 account-details-switch"
                                :labels="{
                                    checked: 'ON',
                                    unchecked: 'OFF',
                                }"
                                :isToolbar="true"
                                :sync="true"
                                v-model="details.client.clientsettings.allow_vrbo"
                            />
                        </div>                        
                        <div
                            v-if="details.client.is_subscriber && details.client.clientsettings.allow_airbnb"
                            class="d-flex flex-column mr-3"
                        >
                            <span>Airbnb Pricing Adjustment:</span>
                            <form-square-switch
                                class="mr-2 account-airbnb-pricing-adjustment-switch"
                                :labels="{
                                    checked: 'ON',
                                    unchecked: 'OFF',
                                }"
                                :isToolbar="true"
                                :sync="true"
                                v-model="details.client.clientsettings.allow_airbnb_pricing_adjustment"
                            />
                        </div>
                        <div v-if="details.client.is_subscriber" class="d-flex flex-column mr-3">
                            <span>Allow Wordpress:</span>
                            <form-square-switch
                                class="mr-2 account-details-switch"
                                :labels="{
                                    checked: 'ON',
                                    unchecked: 'OFF',
                                }"
                                :isToolbar="true"
                                :sync="true"
                                v-model="details.client.clientsettings.allow_wordpress"
                            />
                        </div>
                        <div v-if="details.client.is_subscriber" class="d-flex flex-column mr-3">
                            <span>Display SMS Opt-in:</span>
                            <form-square-switch
                                class="mr-2 account-details-switch"
                                :labels="{
                                    checked: 'ON',
                                    unchecked: 'OFF',
                                }"
                                :isToolbar="true"
                                :sync="true"
                                v-model="details.client.clientsettings.display_sms_optin"
                            />
                        </div>
                        <div v-if="details.client.is_subscriber" class="d-flex flex-column mr-3">
                            <span>Allow AI Assistant:</span>
                            <form-square-switch
                                class="mr-2 account-details-switch"
                                :labels="{
                                    checked: 'ON',
                                    unchecked: 'OFF',
                                }"
                                :isToolbar="true"
                                :sync="true"
                                v-model="details.client.user.lodgix_ai_settings.ai_assistant_enabled"
                            />
                        </div>
                    </div>
                </b-col>
            </b-row>
            <div class="mt-3">
                <div>
                    <h5 class="pt-2">Billing Information</h5>
                    <hr />
                </div>
                <b-row class="flex-column flex-md-row w-100">
                    <b-col>
                        <div class="d-flex flex-column flex-md-row">
                            <form-select
                                floatingLabel="Title"
                                class="w-100 mr-3"
                                :options="prefixOptions"
                                :leftIcon="['fas', 'user']"
                                :value="selectedPrefix"
                                @input="onChangePrefix"
                            ></form-select>
                            <validation-provider
                                name="first_name"
                                v-slot="{ errors, handleChange }"
                                rules="required"
                                class="w-100"
                            >
                                <form-input
                                    floatingLabel="First Name"
                                    :leftIcon="['fas', 'user']"
                                    :error="errors[0]"
                                    v-model="details.client.first_name"
                                    @input="handleChange"
                                ></form-input>
                            </validation-provider>
                        </div>
                        <form-input
                            floatingLabel="Address 1"
                            :leftIcon="['fas', 'location-dot']"
                            v-model="details.client.address.address1"
                        ></form-input>
                        <div class="d-flex flex-column flex-md-row">
                            <form-select
                                :value="selectedCountry"
                                floatingLabel="Country"
                                class="w-100 mr-3"
                                :options="countriesOptions"
                                @change="onChangeCountryName"
                                :leftIcon="['fas', 'location-dot']"
                            ></form-select>
                            <form-input
                                class="w-100"
                                floatingLabel="Zip"
                                :leftIcon="['fas', 'location-dot']"
                                v-model="details.client.address.zip"
                                @input="autoFillCity"
                            ></form-input>
                        </div>
                        <form-input
                            floatingLabel="City"
                            :leftIcon="['fas', 'location-dot']"
                            v-model="details.client.address.city"
                        ></form-input>
                        <validation-provider name="mobile_phone" v-slot="{ errors, handleChange }">
                            <form-phone-number-input
                                inputId="billing-phone"
                                floating-label="Phone"
                                v-model="details.client.address.phone"
                                :default-country-code="defaultCountryCode"
                                :error="errors[0]"
                                @validate="onValidatePhone"
                                @input="handleChange"
                            ></form-phone-number-input>
                        </validation-provider>
                    </b-col>
                    <b-col class="pr-md-0">
                        <validation-provider
                            name="last_name"
                            v-slot="{ errors, handleChange }"
                            rules="required"
                        >
                            <form-input
                                :leftIcon="['fas', 'user']"
                                floatingLabel="Last Name"
                                :error="errors[0]"
                                v-model="details.client.last_name"
                                @input="handleChange"
                            ></form-input>
                        </validation-provider>
                        <form-input
                            floatingLabel="Address 2"
                            :leftIcon="['fas', 'location-dot']"
                            v-model="details.client.address.address2"
                        ></form-input>
                        <span class="form-tip">Your city and state will be automatically added</span>
                        <form-select
                            :leftIcon="['fas', 'location-dot']"
                            :value="selectedState"
                            :options="statesOptions"
                            @change="onChangeState"
                            floatingLabel="State"
                        ></form-select>
                        <form-input
                            v-model="details.client.company"
                            floatingLabel="Company"
                            :leftIcon="['fas', 'building']"
                        ></form-input>
                    </b-col>
                </b-row>
            </div>
            <div>
                <h5 class="pt-2">Change Password</h5>
                <hr />
            </div>
            <b-row class="flex-column flex-md-row w-100">
                <b-col class="mr-md-0 pr-md-0">
                    <validation-provider
                        name="password"
                        v-slot="{ errors, handleChange }"
                        rules="validAccountPassword"
                    >
                        <input type="text" style="display: none" />
                        <input type="password" style="display: none" />
                        <form-input
                            autocomplete="new-password"
                            v-model="newPassword"
                            floatingLabel="New Password"
                            :leftIcon="['fas', 'lock']"
                            :error="errors[0]"
                            placeholder="Fill to change password, otherwise leave empty"
                            @input="handleChange"
                        ></form-input>
                    </validation-provider>
                    <b-button class="save-button" variant="primary" @click="saveAccountDetails" :disabled="!meta.valid">
                        Save
                    </b-button>
                </b-col>
            </b-row>
        </validation-observer>
    </b-container>
</template>

<script>
import debounce from 'lodash/debounce';
import isEmpty from 'lodash/isEmpty';
import FormCheckbox from '../../../generic/form-checkbox/form-checkbox.vue';
import FormInput from '../../../generic/form-input/form-input.vue';
import FormSelect from '../../../generic/form-select/form-select.vue';
import FormSquareSwitch from '../../../generic/form-square-switch/form-square-switch.vue';
import { formatResponseError } from '../../../../utils/api';
import PhoneNumber from 'awesome-phonenumber';
import Modal from '../../../generic/modal/modal.vue';
import API from '../../../../api';
import { ADMIN_SUBSCRIBER_ACCOUNT_DETAILS, ACCOUNT_AUTOFILL_VIA_ZIP_ENDPOINT } from '../../../../endpoints';
import { mapActions, mapGetters, mapState } from 'vuex';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import FormApiKeyField from '../../../generic/form-api-key-field/form-api-key-field.vue';
import { defineAsyncComponent } from 'vue';

const FormPhoneNumberInput = defineAsyncComponent(() =>
    import(
        /* webpackChunkName: "lx-form-phone-number-input" */
        '../../../generic/form-phone-number-input/form-phone-number-input.vue'
    )
);

export default {
    components: {
        FormCheckbox,
        FormInput,
        FormSelect,
        FormPhoneNumberInput,
        Modal,
        FormSquareSwitch,
        FormApiKeyField,
    },
    data() {
        return {
            values: null,
            newPassword: null,
        };
    },
    computed: {
        ...mapGetters('adminSubscriberAccount', ['details', 'statesOptions', 'countriesOptions']),
        ...mapGetters('header', ['userUnicodeDateFormat']),
        ...mapState({
            selectedState: (state) => state.adminSubscriberAccount.selectedState,
            selectedCountry: (state) => state.adminSubscriberAccount.selectedCountry,
            selectedPrefix: (state) => state.adminSubscriberAccount.selectedPrefix,
            countryList: (state) => state.adminSubscriberAccount.countryList,
            stateList: (state) => state.adminSubscriberAccount.stateList,
        }),
        prefixOptions() {
            return [
                { value: 1, text: 'Mr.' },
                { value: 10, text: 'Mrs.' },
                { value: 11, text: 'Ms.' },
                { value: 56, text: 'Mr. & Mrs' },
                { value: 7301, text: 'Dr.' },
            ];
        },
        defaultCountryCode() {
            if (this.details.client.address.phone) {
                const phone = PhoneNumber(this.details.client.address.phone);
                return phone.g.regionCode;
            }
            return '';
        },
        initialFormValues() {
            return this.details.client
                ? {
                      email: this.details.client.user.email,
                      emaiL_cc: this.details.client.is_subscriber
                          ? this.details.client.user.email_cc
                          : this.details.client.email,
                      first_name: this.details.client.first_name,
                      last_name: this.details.client.last_name,
                  }
                : {};
        },
    },
    methods: {
        ...mapActions('adminSubscriberAccount', ['fetchStates']),
        formatDate(value) {
            return value && format(parseISO(value), this.userUnicodeDateFormat);
        },
        onValidatePhone(value) {
            if (value.isValid) {
                this.details.client.address.phone = value.number.e164;
            }
        },
        autoFillCity: debounce(async function (value) {
            if (value) {
                try {
                    this.$parent.$emit('busy', true);
                    const response = await API.get(ACCOUNT_AUTOFILL_VIA_ZIP_ENDPOINT(this.selectedCountry, value));
                    if (response.data.city) {
                        const details = JSON.parse(
                            JSON.stringify({
                                ...this.details,
                            })
                        );
                        details.client.address.city = response.data.city;
                        const selectedState = this.statesOptions.find((item) => {
                            return item.text === response.data.state;
                        });
                        const selectedCountry = this.countryList.find((item) => item.code === response.data.country);
                        details.client.address.country = selectedCountry;
                        details.client.address.state = selectedState;
                        this.$store.commit('adminSubscriberAccount/gotDetails', details);
                        this.$store.commit('adminSubscriberAccount/gotSelectedCountry', selectedCountry.id);
                        this.$store.commit('adminSubscriberAccount/gotSelectedState', selectedState.value);
                    } else {
                        this.warningToast({
                            text: 'Unable to auto fill city and state',
                        });
                    }
                } catch (e) {
                    console.log(e);
                    this.errorToast({ text: 'Could not load state and city' });
                } finally {
                    this.$parent.$emit('busy', false);
                }
            }
        }, 1000),
        onChangePrefix(value) {
            this.$store.commit('adminSubscriberAccount/gotSelectedPrefix', value);
        },
        onChangeState(value) {
            this.$store.commit('adminSubscriberAccount/gotSelectedState', value);
        },
        async onChangeCountryName(value) {
            this.$parent.$emit('busy', true);
            await this.$store.dispatch('adminSubscriberAccount/onChangeCountry', {
                id: value,
            });
            this.$parent.$emit('busy', false);
        },
        async saveAccountDetails() {
            try {
                this.$parent.$emit('busy', true);
                const body = {
                    ...this.details.client,
                };
                const selectedCountry = this.countryList.find((item) => item.id === this.selectedCountry);
                const selectedState = this.stateList.find((item) => item.id === this.selectedState);
                const selectedPrefix = this.prefixOptions.find((item) => item.value === this.selectedPrefix);
                body.address.country = selectedCountry;
                body.address.state = selectedState;
                body.title = {
                    id: selectedPrefix.value,
                    name: selectedPrefix.text,
                };
                body.user.password = this.newPassword;
                await API.patch(ADMIN_SUBSCRIBER_ACCOUNT_DETAILS(body.user.id), body);
                this.newPassword = null;
                this.successToast({
                    text: 'User details successfully updated.',
                });
            } catch (e) {
                const { fields, generic } = formatResponseError(e);
                if (e.response.data.address) {
                    this.errorToast({ text: e.response.data.address.phone[0] });
                } else {
                    this.errorToast({ text: generic || 'Could not save data' });
                }
                if (!generic && !isEmpty(fields)) {
                    this.$refs.account_form.setErrors(fields);
                }
            } finally {
                this.$parent.$emit('busy', false);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.account-details-switch {
    width: 90px;
}
.account-airbnb-pricing-adjustment-switch {
    width: 150px;
}
.form-tip {
    display: flex;
    align-items: center;
    height: 40px;
    margin-bottom: 1rem;
}
.save-button {
    @media (max-width: 799px) {
        width: 100%;
    }
}
</style>
